module.exports = __webpack_public_path__ + "static/media/md-battery-dead.508de4eb.svg";